import { Component, OnInit } from '@angular/core';
import { SimpleModalComponent } from 'ngx-simple-modal';
import { HttpUtils } from '../common/http-utils';
import { LoaderService } from '../common/loader-service';
import { Constants } from '../common/constants';
import { LocalStorage } from '../common/local-storage';
import { Toast } from '../common/toast';
import { MemoryStorage } from '../common/memory-storage';
import { KeycloakService } from 'keycloak-angular';
import { Tags } from '../common/tags';
import { Utils } from '../common/utils';
import { environment } from 'src/environments/environment';



export interface PaymentGatewayInterface {
  applicationsList: any[];
}


@Component({
  selector: 'app-select-payment-modal',
  templateUrl: './select-payment-modal.component.html',
  styleUrls: ['./select-payment-modal.component.css']
})
export class SelectPaymentModalComponent
  extends SimpleModalComponent<PaymentGatewayInterface, string>
  implements PaymentGatewayInterface {
  gateways: any = [
  ]
  applicationsList: []
  selectedPaymentMode: string = this.constants.BLANK
  paymentFormObject: any = {};
  termsAccepted: boolean = false;
  refundPolicyUrl: string = environment.refundPolicyUrl;
  private loggedUserId: string = this.constants.BLANK;

  constructor(private httpUtils: HttpUtils, public utils: Utils, private tags: Tags, private loaderService: LoaderService, private readonly keycloakService: KeycloakService, private browserStorageService: MemoryStorage, public constants: Constants, private localStorage: LocalStorage, private toast: Toast) {
    super();
    this.getAllPaymentGate()
    this.loggedUserId = this.localStorage.getLoggedUserId();

  }

  trackByGateway(index: number, gateway: any): string {
    return gateway.id || index;
  }

  onPaymentMethodChange(gateway: any): void {

    if (gateway) {
      this.selectedPaymentMode = gateway.gatewayName
    }

  }


  getGatewayImage(gatewayName: string): string {
    const images = {
      'HYDROGENPAY': 'assets/images/hydrogenpay-logo.png',
      'PAYSTACK': 'assets/images/paystack-logo.png',
      'PAYFIXY RAVE': 'assets/images/payfixy.svg',
      'PAYFIXY': 'assets/images/payfixy.svg'
    };

    return images[gatewayName.toUpperCase()] || 'assets/images/default-gateway-logo.png';
  }

  private getAllPaymentGate() {
    this.loaderService.startLoader();

    this.httpUtils.fetchAllPaymentGateway().then(serverResponse => {
      this.gateways = serverResponse.paymentGateway;
      this.loaderService.stopLoader();

    });
  }


  async makePayment(): Promise<void> {
    this.loaderService.startLoader();

    try {

      this.saveAuthToken();
      const payload = {
        loggedUserId: this.loggedUserId,
        applicationsList:
          this.applicationsList
        ,
        paymentGateway: this.selectedPaymentMode
      }


      this.httpUtils.makeApplicationPayment(payload).then(serverResponse => {
        this.loaderService.startLoader();

        const paymentUrl = serverResponse?.redirectUrl;
        if (paymentUrl) {
          window.location.href = serverResponse?.redirectUrl
        } else {
          this.toast.showErrorToast("Payment failed, Please try again later");
        }

        this.loaderService.stopLoader();

      });


    } catch (error) {
      let errorMessage = 'Payment failed, Please try again later';
      this.toast.showErrorToast(errorMessage);
    } finally {
      this.loaderService.stopLoader();
    }
  }


  closeModal() {
    this.close();
  }

  isEmpty(value: string) {
    return !value || value.trim() === '';
  }

  private saveAuthToken(): void {
    const authorizationWithKey = true;
    const encryptedAuthorizationWithKey = this.utils.encryptString(
      authorizationWithKey.toString()
    );

    this.localStorage.setSessionStorageKey(this.tags.APPLICATION_TOKEN, this.browserStorageService.get(this.tags.APPLICATION_TOKEN));
    this.localStorage.setSessionStorageKey(this.tags.AUTHORIZATION, encryptedAuthorizationWithKey);
    this.localStorage.setSessionStorageKey(this.tags.KEYCLOAK_TOKEN, this.keycloakService.getKeycloakInstance().token);
    this.localStorage.setSessionStorageKey(this.tags.LOGGED_USER_ID, this.browserStorageService.get(this.tags.LOGGED_USER_ID));
    this.localStorage.setSessionStorageKey(this.tags.LOGGED_USER_NAME, this.browserStorageService.get(this.tags.LOGGED_USER_NAME));
    this.localStorage.setSessionStorageKey(this.tags.KEYCLOAK_REFRESH_TOKEN, this.keycloakService.getKeycloakInstance().refreshToken);

  }




}
